// extracted by mini-css-extract-plugin
module.exports = {"cart":"BasketDetails_cart__268E5","hide":"BasketDetails_hide__2B2GD","itemContainer":"BasketDetails_itemContainer__1Y5xO"};